module.exports = __webpack_public_path__ + "img/klaviyo.0b563b1e.webp";